export const PRODUCTS_ON_PAGE_LIMIT = 30;
